<template>
    <section>
        <h3 class="text-uppercase mt-4">Deactivate Account</h3>
        <hr class="bar my-3" />
        <button
            id="pre-deactivate"
            @click="preDeactivateAccount()"
            class="btn btn-sm btn-outline btn-danger text-white"
        >
            Deactivate Account
        </button>
        <modal
            id="deactivate-modal"
            :visible="isVisible"
            title="Deactivate Account"
            @close="resetModal()"
        >
            <!--DEACTIVATE ACCOUNT-->
            <div>
                <p>
                    Are you absolutely sure? Deactivating this account will prevent registration and
                    login using this email ever again. Any team members invited to this organization
                    (<strong>{{ organization.name }}</strong
                    >) will also be unable to log in.
                </p>
                <p>
                    Please note: We reserve the right to delete account data on deactivated accounts
                    after 60 days.
                </p>
                <div class="d-flex w-100 justify-content-between align-items-center py-3">
                    <button
                        class="small btn btn-sm btn-link text-primary font-weight-bold text-uppercase"
                        @click.prevent="resetModal()"
                    >
                        No, don't deactivate
                    </button>
                    <button
                        id="deactivate"
                        dusk="deactivate"
                        class="btn btn-sm btn-danger font-weight-bold text-uppercase text-white"
                        @click.prevent="deactivateAccount()"
                    >
                        Yes, deactivate
                    </button>
                </div>
            </div>
        </modal>
    </section>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import Modal from "../ui/ModalComponent";

export default {
    name: "AccountDeactivate",
    props: ["user", "organization"],
    components: { Modal },
    data() {
        return {
            delete_token: null,
            isVisible: false,
        };
    },
    methods: {
        preDeactivateAccount() {
            helpers.toggleSpinner("pre-deactivate");
            axios
                .get(`/api/users/${this.user.id}/delete_token`)
                .then(r => {
                    helpers.toggleSpinner("pre-deactivate");
                    this.delete_token = r.data.data;
                    this.isVisible = true;
                })
                .catch(e => {
                    helpers.toggleSpinner("pre-deactivate");
                    console.error(e);
                });
        },

        deactivateAccount() {
            helpers.toggleSpinner("deactivate");
            axios
                .delete(`/api/users/${this.user.id}/${this.delete_token}`)
                .then(r => {
                    helpers.toggleSpinner("deactivate");
                    this.signout();
                })
                .catch(e => {
                    helpers.toggleSpinner("deactivate");
                    console.error(e);
                });
        },

        signout() {
            axios
                .post("/logout")
                .then(() => {
                    window.location.href = this.$root.appUrl;
                })
                .catch(e => {
                    console.error(e);
                    window.location.href = this.$root.appUrl;
                });
        },

        resetModal() {
            this.isVisible = false;
            this.delete_token = null;
        },
    },
};
</script>

<style scoped></style>
